import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {CityProps} from '../types';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import {UserProps} from 'modules/users/types';
import citiesKeys from '../util/cities-keys';

const useEditCityAvailability = () => {
  const {accessControl} = useAccessControls();
  const {setData, getData} = useQueryHelpers();

  const onSuccess = (data: CityProps) => {
    setData(citiesKeys.details(accessControl!.cityId!), data);
    const profile = getData<UserProps>('/users/me');

    if (!profile) return;

    setData('/users/me', {
      ...profile,
      accessControls: profile.accessControls.map((someAccessControl) =>
        someAccessControl.id === accessControl?.id
          ? {...someAccessControl, city: data}
          : someAccessControl,
      ),
    });
  };

  return useApiMutation({
    url: `/cities/${accessControl?.cityId}/availability`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar cidade',
    onSuccess,
  });
};

export default useEditCityAvailability;
